import { LaborupGear } from "@/components/LaborupGear";

import { laborupGearColor } from "@/lib/constants";
import { cn } from "@/lib/utils";

const variantSizes = {
  xsmall: 10,
  small: 16,
  medium: 30,
  large: 48,
  xlarge: 60,
} as const;

export type LoadingIndicatorVariant = keyof typeof variantSizes;

export const LoadingIndicator = ({
  className,
  gearColor = laborupGearColor,
  variant = "medium",
}: {
  className?: string;
  gearColor?: string;
  variant?: LoadingIndicatorVariant;
}) => {
  const size = variantSizes[variant];

  return (
    <div className={cn("flex items-center justify-center", className)}>
      <div className="animate-spin" style={{ animationDuration: "1.5s" }}>
        <LaborupGear color={gearColor} height={size} width={size} />
      </div>
    </div>
  );
};
